import constantsCommon from '$$helpers/constants';
import getSvgIcon from '../../../helpers/getSvgIcon';

class UiManager {
  #instance;

  init(instance) {
    this.#instance = instance;
  }

  toggleColumnsHeadersControlls(disable) {
    const headsWrapper = document.querySelector('.gantt_grid_scale');

    if (disable) {
      headsWrapper.classList.add('gantt_grid_head_disable_controlls');
    } else {
      headsWrapper.classList.remove('gantt_grid_head_disable_controlls');
    }
  }

  toggleCellsOpacity(draggedData, enable) {
    const tableCells = document.querySelectorAll(`.gantt_cell[data-name='${draggedData.draggedColumn.name}']`);

    if (enable) {
      tableCells.forEach(task => task.classList.add('opacity-table-cell'));
    } else {
      tableCells.forEach(task => task.classList.remove('opacity-table-cell'));
    }
  }

  removeTargetMarkerLong() {
    const gridTargetMarkerLong = document.querySelector('.gantt_grid_target_marker_long');

    if (!gridTargetMarkerLong) return;
    this.#instance.$grid.removeChild(gridTargetMarkerLong);
  }

  addTargetMarkerLong() {
    this.removeTargetMarkerLong();
    const gridTargetMarker = document.querySelector('.gantt_grid_target_marker');

    if (!gridTargetMarker) return;

    const gridTargetMarkerDomRect = gridTargetMarker.getBoundingClientRect();

    const targetMarker = document.createElement('div');
    const height = this.#instance.serialize().data.length * this.#instance.config.row_height < this.#instance.$ui.getView('grid').$config.height
      ? this.#instance.serialize().data.length * this.#instance.config.row_height
      : this.#instance.$ui.getView('grid').$config.height;

    targetMarker.classList.add('gantt_grid_target_marker_long');
    targetMarker.style.height = `${height}px`;
    targetMarker.style.top = `${this.#instance.config.scale_height}px`;
    targetMarker.style.left = `${gridTargetMarkerDomRect.left - this.#instance.ganttDataApi.getLeftSidebarWidth() + 3}px`;
    this.#instance.$grid.appendChild(targetMarker);
  }

  updateColumnsHeaders() {
    const button = document.querySelector('.gantt_grid_head_buttons');
    const elements = document.querySelectorAll('.gantt_grid_head_cell');

    if (button) {
      if (this.#instance.config.grid_width >= this.#instance.$container.offsetWidth) {
        button.classList.add('fixed');
        button.style.left = `${this.#instance.$container.offsetWidth - button.offsetWidth - 2}px`;
      } else {
        button.classList.remove('fixed');
      }
    }

    elements.forEach(el => {
      const columnId = el.getAttribute('data-column-id');

      if (!constantsCommon.COLUMN_ORDER.NOT_HIDABLE.includes(columnId) && this.#instance.ganttDataApi.isBase()) {
        el.classList.add('hideable_column');
        if (!el.querySelectorAll('.hide_column_button').length) {
          const node = document.createElement('div');

          node.classList.add('grid_header_control');
          node.classList.add('hide_column_button');
          node.innerHTML = getSvgIcon('close-1', 'regular', 16);
          el.appendChild(node);
        }
      }

      if (!constantsCommon.COLUMN_ORDER.NOT_DRAGABLE.includes(columnId) && this.#instance.ganttDataApi.isBase()) {
        el.classList.add('dragable_column');
        if (!el.querySelectorAll('.drag-column-indicator').length) {
          const node = document.createElement('div');

          node.classList.add('drag-column-indicator', 'grid_header_control');
          node.innerHTML = getSvgIcon('dragdrop', 'regular', 24);
          el.appendChild(node);
        }
      }
    });
  }
}

export default new UiManager();
